import 'js/common.js'
import Vue from 'vue'
import RemoveLimit from 'component/sign/RemoveLimit.vue'

new Vue({
    el: '#app',
    render: h => h(RemoveLimit)
})



// WEBPACK FOOTER //
// ./src/entry/sign/removeLimit.js